import "./App.css";
import EwbManuallyStopped from "./components/EwbManuallyStopped";
import Login from "./components/Login";
import useSessionVariables from "./components/useSessionVariables.js";
import { BrowserRouter, Routes, Route, Link, Navigate } from "react-router-dom";
import React from "react";
import Dashboard from "./components/dashboard/Dashboard.js";
import { CompanySettingsProvider } from "./utils/CompanySettingsContext.js";
// import Signup from './components/Signup';

function App() {
  const sessionObject = useSessionVariables();

  return (
    <CompanySettingsProvider>
      <BrowserRouter>
        {console.log(
          "session object",
          sessionObject.sessionVariables.access_token,
        )}

        {!(
          sessionObject.sessionVariables.access_token ||
          sessionStorage.getItem("login")
        ) ? (
          //<Signup/>
          <Routes>
            <Route
              path="/"
              exact
              element={<Login sessionObject={sessionObject} />}
            />
            <Route path="*" element={<Login sessionObject={sessionObject} />} />
          </Routes>
        ) : (
          <Routes>
            {/* <Route path="" element={<Users />} /> */}
            {/*<Route path='/' exact element={<Login sessionObject={sessionObject}/>}/>*/}
            {/* <Route path='/signup' element = {<Signup/>} /> */}

            <Route
              path="/ewb"
              element={
                sessionStorage.getItem("user_id") === "246" ? (
                  <Navigate to="/dashboard" replace />
                ) : (
                  <EwbManuallyStopped sessionObject={sessionObject} />
                )
              }
            />

            <Route
              path="/dashboard"
              element={
                sessionStorage.getItem("user_id") === "246" ? (
                  <Dashboard sessionObject={sessionObject} />
                ) : (
                  <Navigate to="/ewb" replace />
                )
              }
            />

            <Route
              path="*"
              element={
                sessionStorage.getItem("user_id") === "246" ? (
                  <Navigate to="/dashboard" replace />
                ) : (
                  <Navigate to="/ewb" replace />
                )
              }
            />
          </Routes>
        )}
      </BrowserRouter>
    </CompanySettingsProvider>
  );
}

export default App;
